
export const DTREES_ACTIONS = {
	VIEW_DTREE_MODAL				: "VIEW_DTREE_MODAL",
	CLEAR_DTREE_MODAL				: "CLEAR_DTREE_MODAL",
	LOAD_DTREES_AJAX				: "LOAD_DTREES_AJAX",
	LOAD_DTREES_SUCCESS				: "LOAD_DTREES_SUCCESS",
	LOAD_DTREES_ERROR				: "LOAD_DTREES_ERROR",

	DUPLICATE_DTREE_AJAX			: "DUPLICATE_DTREE_AJAX",
	DUPLICATE_DTREE_SUCCESS			: "DUPLICATE_DTREE_SUCCESS",
	DUPLICATE_DTREE_ERROR			: "DUPLICATE_DTREE_ERROR",

	FETCH_DTREE_NAME            : "FETCH_DTREE_NAME",
	FETCH_DTREE_NAME_SUCCESS    : "FETCH_DTREE_NAME_SUCCESS",
	FETCH_DTREE_NAME_ERROR      : "FETCH_DTREE_NAME_ERROR",

	UNASSIGN_DTREES_AJAX			: "UNASSIGN_DTREES_AJAX",
	UNASSIGN_DTREES_AJAX_SUCCESS	: "UNASSIGN_DTREES_AJAX_SUCCESS",
	UNASSIGN_DTREES_AJAX_ERROR		: "UNASSIGN_DTREES_AJAX_ERROR",

	ASSIGN_DTREES_AJAX				: "ASSIGN_DTREES_AJAX",
	ASSIGN_DTREES_AJAX_SUCCESS		: "ASSIGN_DTREES_AJAX_SUCCESS",
	ASSIGN_DTREES_AJAX_ERROR		: "ASSIGN_DTREES_AJAX_ERROR",

	FETCH_DTREE_LINKED_CREATIVES            : "FETCH_DTREE_LINKED_CREATIVES",
	FETCH_DTREE_LINKED_CREATIVES_SUCCESS    : "FETCH_DTREE_LINKED_CREATIVES_SUCCESS",
	FETCH_DTREE_LINKED_CREATIVES_ERROR      : "FETCH_DTREE_LINKED_CREATIVES_ERROR",
};
